/**
 * @flow
 * @relayHash ce45b85d002a9d187fadf8b6725418e8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SmartCartInputQuery = {
  name?: ?string
};
export type CreateSmartCartMutationVariables = {|
  input?: ?SmartCartInputQuery
|};
export type CreateSmartCartMutationResponse = {|
  +add_smart_cart: ?{|
    +errors: ?$ReadOnlyArray<?{|
      +code: ?number,
      +field: ?string,
      +messages: ?$ReadOnlyArray<?string>,
    |}>,
    +current_user: ?{|
      +id: string,
      +ref_id: string,
      +first_name: ?string,
      +last_name: ?string,
      +avatar: ?string,
      +email: ?string,
      +nationality: ?{|
        +ref_id: string,
        +name: ?string,
      |},
      +city: ?{|
        +ref_id: string,
        +name: ?string,
      |},
      +country: ?{|
        +ref_id: string,
        +name: ?string,
        +phone_code: ?string,
      |},
      +country_code: ?string,
      +phone_number: ?string,
      +mobile_number: ?string,
      +gender: ?string,
      +birthdate_timestamp: ?number,
      +short_address: ?string,
      +newsletter_subscription: ?boolean,
      +receive_push_notifications: ?boolean,
      +default_lang: ?string,
      +default_currency: ?string,
      +errors: ?$ReadOnlyArray<?{|
        +code: ?number,
        +field: ?string,
        +messages: ?$ReadOnlyArray<?string>,
      |}>,
      +shipping_addresses_previous: $ReadOnlyArray<?{|
        +id: string,
        +ref_id: string,
        +phone: ?string,
        +phone_code: ?string,
        +full_name: ?string,
        +firstname: ?string,
        +lastname: ?string,
        +address1: ?string,
        +lat: ?number,
        +lng: ?number,
        +inwani_building: ?number,
        +inwani_street: ?number,
        +inwani_zone: ?number,
        +country: {|
          +name: ?string,
          +ref_id: string,
          +phone_code: ?string,
          +accept_delivery_and_shipping: ?boolean,
        |},
        +state: ?{|
          +name: ?string,
          +ref_id: string,
        |},
        +save_as_default: ?boolean,
      |}>,
      +billing_addresses_previous: $ReadOnlyArray<?{|
        +id: string,
        +ref_id: string,
        +phone: ?string,
        +phone_code: ?string,
        +full_name: ?string,
        +firstname: ?string,
        +lastname: ?string,
        +address1: ?string,
        +lat: ?number,
        +lng: ?number,
        +inwani_building: ?number,
        +inwani_street: ?number,
        +inwani_zone: ?number,
        +country: {|
          +name: ?string,
          +ref_id: string,
          +phone_code: ?string,
          +accept_delivery_and_shipping: ?boolean,
        |},
        +state: ?{|
          +name: ?string,
          +ref_id: string,
        |},
        +save_as_default: ?boolean,
      |}>,
      +club: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +club_attachment: ?{|
        +name: ?string
      |},
      +phone_provider: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +phone_provider_attachment: ?{|
        +name: ?string
      |},
      +school: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +school_attachment: ?{|
        +name: ?string
      |},
      +employer: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +employer_attachment: ?{|
        +name: ?string
      |},
      +insurance_company: ?{|
        +id: string,
        +name: ?string,
        +ref_id: string,
      |},
      +insurance_company_attachment: ?{|
        +name: ?string
      |},
      +smart_carts: ?$ReadOnlyArray<?{|
        +name: ?string,
        +quantity: number,
        +id: string,
        +ref_id: string,
        +amount: number,
      |}>,
      +ayk_loyalty_program: ?{|
        +degree: ?string,
        +active_gifts_count: ?number,
        +id: string,
        +points: ?number,
        +points_to_next_gift: ?number,
        +points_to_next_level: ?number,
        +qr_code: ?{|
          +url_thumb: ?string
        |},
        +ref_id: string,
        +type: ?string,
        +vendor: ?{|
          +name: ?string,
          +logo_url: ?string,
        |},
        +silver_start_at: ?number,
        +gold_start_at: ?number,
        +diamond_start_at: ?number,
      |},
      +vendor_loyalty_programs: ?$ReadOnlyArray<?{|
        +degree: ?string,
        +active_gifts_count: ?number,
        +id: string,
        +points: ?number,
        +points_to_next_gift: ?number,
        +points_to_next_level: ?number,
        +qr_code: ?{|
          +url_thumb: ?string
        |},
        +ref_id: string,
        +type: ?string,
        +vendor: ?{|
          +name: ?string,
          +logo_url: ?string,
        |},
        +silver_start_at: ?number,
        +gold_start_at: ?number,
        +diamond_start_at: ?number,
      |}>,
      +referring_code: ?string,
    |},
    +smart_cart: ?{|
      +id: string,
      +ref_id: string,
      +name: ?string,
      +amount: number,
      +amount_in_qar: number,
      +quantity: number,
      +shipping_price: number,
      +raw_amount: number,
      +services_only: ?boolean,
      +least_state: ?string,
      +promo_code: ?string,
      +discount: number,
      +taxes: number,
      +selected_shipping_address: ?{|
        +ref_id: string
      |},
      +selected_billing_address: ?{|
        +ref_id: string
      |},
      +smart_cart: ?boolean,
      +user_smart_cart: ?boolean,
      +same_as_shipping: ?boolean,
      +payment_reference: ?string,
      +amount_with_cash: number,
      +amount_with_credit: number,
      +orders: $ReadOnlyArray<?{|
        +guest_token: ?string,
        +amount: number,
        +id: string,
        +product_type: ?string,
        +selected_billing_address_id: ?number,
        +selected_shipping_address_id: ?number,
        +same_as_shipping: ?boolean,
        +vendor_branch_id: ?number,
        +ref_id: string,
        +total: number,
        +notes: ?string,
        +state: string,
        +promo_total: number,
        +tax_total: number,
        +adjustment_total: number,
        +free_shipping: ?boolean,
        +available_payment_methods: ?$ReadOnlyArray<?{|
          +ref_id: string,
          +id: string,
          +name: string,
        |}>,
        +line_items: $ReadOnlyArray<?{|
          +created_at: ?any,
          +amount: number,
          +price: number,
          +warnings: ?$ReadOnlyArray<?{|
            +field: ?string,
            +messages: ?$ReadOnlyArray<?string>,
            +blocking: ?boolean,
          |}>,
          +id: string,
          +quantity: number,
          +variant_services: ?$ReadOnlyArray<?{|
            +ref_id: string
          |}>,
          +variant: {|
            +name: string,
            +id: string,
            +ref_id: string,
            +images: $ReadOnlyArray<?string>,
            +price: number,
            +slug: ?string,
            +vendor_variants_count: ?number,
            +min_variant: ?{|
              +vendor: ?{|
                +name: ?string,
                +ref_id: string,
              |}
            |},
            +total_on_hand: ?number,
            +display_price: ?string,
            +images_attachments: $ReadOnlyArray<?{|
              +url_original: string,
              +url_small: string,
            |}>,
            +option_values: ?$ReadOnlyArray<?{|
              +id: string,
              +name: ?string,
              +presentation: ?string,
            |}>,
            +vendor: ?{|
              +name: ?string,
              +active: ?boolean,
            |},
          |},
          +total: number,
        |}>,
        +vendor: {|
          +name: ?string,
          +branches: ?$ReadOnlyArray<?{|
            +ref_id: string,
            +name: string,
            +address: ?string,
            +lat: ?number,
            +lng: ?number,
            +inwani_building: ?number,
            +inwani_street: ?number,
            +inwani_zone: ?number,
          |}>,
          +payment_methods: $ReadOnlyArray<?{|
            +ref_id: string,
            +name: string,
          |}>,
        |},
        +vendor_branch: ?{|
          +ref_id: string,
          +name: string,
          +address: ?string,
          +lat: ?number,
          +lng: ?number,
          +inwani_building: ?number,
          +inwani_street: ?number,
          +inwani_zone: ?number,
        |},
        +payments: $ReadOnlyArray<?{|
          +payment_method: {|
            +ref_id: string,
            +name: string,
          |}
        |}>,
        +shipments: $ReadOnlyArray<?{|
          +ref_id: string,
          +shipping_rates: $ReadOnlyArray<?{|
            +ref_id: string,
            +base_price: ?number,
            +shipping_method: {|
              +calculator: ?{|
                +type: string
              |},
              +ref_id: string,
              +name: ?string,
              +estimated_delivery_time: ?string,
            |},
          |}>,
          +shipping_rate_selected: ?{|
            +ref_id: string,
            +base_price: ?number,
            +shipping_method: {|
              +calculator: ?{|
                +type: string
              |},
              +ref_id: string,
              +name: ?string,
              +estimated_delivery_time: ?string,
            |},
          |},
        |}>,
      |}>,
      +promotions: ?$ReadOnlyArray<?{|
        +ref_id: string,
        +code: ?string,
      |}>,
      +user: ?{|
        +avatar_details: ?{|
          +url_original: ?string,
          +name: ?string,
        |},
        +first_name: ?string,
        +last_name: ?string,
      |},
    |},
  |}
|};
export type CreateSmartCartMutation = {|
  variables: CreateSmartCartMutationVariables,
  response: CreateSmartCartMutationResponse,
|};
*/


/*
mutation CreateSmartCartMutation(
  $input: SmartCartInputQuery
) {
  add_smart_cart(input: $input) {
    errors {
      code
      field
      messages
    }
    current_user {
      id
      ref_id
      first_name
      last_name
      avatar
      email
      nationality {
        ref_id
        name
        id
      }
      city {
        ref_id
        name
        id
      }
      country {
        ref_id
        name
        phone_code
        id
      }
      country_code
      phone_number
      mobile_number
      gender
      birthdate_timestamp
      short_address
      newsletter_subscription
      receive_push_notifications
      default_lang
      default_currency
      errors {
        code
        field
        messages
      }
      shipping_addresses_previous {
        id
        ref_id
        phone
        phone_code
        full_name
        firstname
        lastname
        address1
        lat
        lng
        inwani_building
        inwani_street
        inwani_zone
        country {
          name
          ref_id
          phone_code
          accept_delivery_and_shipping
          id
        }
        state {
          name
          ref_id
          id
        }
        save_as_default
      }
      billing_addresses_previous {
        id
        ref_id
        phone
        phone_code
        full_name
        firstname
        lastname
        address1
        lat
        lng
        inwani_building
        inwani_street
        inwani_zone
        country {
          name
          ref_id
          phone_code
          accept_delivery_and_shipping
          id
        }
        state {
          name
          ref_id
          id
        }
        save_as_default
      }
      club {
        id
        name
        ref_id
      }
      club_attachment {
        name
      }
      phone_provider {
        id
        name
        ref_id
      }
      phone_provider_attachment {
        name
      }
      school {
        id
        name
        ref_id
      }
      school_attachment {
        name
      }
      employer {
        id
        name
        ref_id
      }
      employer_attachment {
        name
      }
      insurance_company {
        id
        name
        ref_id
      }
      insurance_company_attachment {
        name
      }
      smart_carts {
        name
        quantity
        id
        ref_id
        amount
      }
      ayk_loyalty_program {
        degree
        active_gifts_count
        id
        points
        points_to_next_gift
        points_to_next_level
        qr_code {
          url_thumb
        }
        ref_id
        type
        vendor {
          name
          logo_url
          id
        }
        silver_start_at
        gold_start_at
        diamond_start_at
      }
      vendor_loyalty_programs {
        degree
        active_gifts_count
        id
        points
        points_to_next_gift
        points_to_next_level
        qr_code {
          url_thumb
        }
        ref_id
        type
        vendor {
          name
          logo_url
          id
        }
        silver_start_at
        gold_start_at
        diamond_start_at
      }
      referring_code
    }
    smart_cart {
      id
      ref_id
      name
      amount
      amount_in_qar
      quantity
      shipping_price
      raw_amount
      services_only
      least_state
      promo_code
      discount
      taxes
      selected_shipping_address {
        ref_id
        id
      }
      selected_billing_address {
        ref_id
        id
      }
      smart_cart
      user_smart_cart
      same_as_shipping
      payment_reference
      amount_with_cash
      amount_with_credit
      orders {
        guest_token
        amount
        id
        product_type
        selected_billing_address_id
        selected_shipping_address_id
        same_as_shipping
        vendor_branch_id
        ref_id
        total
        notes
        state
        promo_total
        tax_total
        adjustment_total
        free_shipping
        available_payment_methods {
          ref_id
          id
          name
        }
        line_items {
          created_at
          amount
          price
          warnings {
            field
            messages
            blocking
          }
          id
          quantity
          variant_services {
            ref_id
            id
          }
          variant {
            name
            id
            ref_id
            images
            price
            slug
            vendor_variants_count
            min_variant {
              vendor {
                name
                ref_id
                id
              }
              id
            }
            total_on_hand
            display_price
            images_attachments {
              url_original
              url_small
            }
            option_values {
              id
              name
              presentation
            }
            vendor {
              name
              active
              id
            }
          }
          total
        }
        vendor {
          name
          branches {
            ref_id
            name
            address
            lat
            lng
            inwani_building
            inwani_street
            inwani_zone
            id
          }
          payment_methods {
            ref_id
            name
            id
          }
          id
        }
        vendor_branch {
          ref_id
          name
          address
          lat
          lng
          inwani_building
          inwani_street
          inwani_zone
          id
        }
        payments {
          payment_method {
            ref_id
            name
            id
          }
          id
        }
        shipments {
          ref_id
          shipping_rates {
            ref_id
            base_price
            shipping_method {
              calculator {
                type
                id
              }
              ref_id
              name
              estimated_delivery_time
              id
            }
            id
          }
          shipping_rate_selected {
            ref_id
            base_price
            shipping_method {
              calculator {
                type
                id
              }
              ref_id
              name
              estimated_delivery_time
              id
            }
            id
          }
          id
        }
      }
      promotions {
        ref_id
        code
        id
      }
      user {
        avatar_details {
          url_original
          name
        }
        first_name
        last_name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SmartCartInputQuery",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SmartCartInputQuery"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "field",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "messages",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    v2,
    v3,
    v4
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "default_currency",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "first_name",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "last_name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "avatar",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v14 = [
  v12,
  v13
],
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone_code",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country_code",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone_number",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "mobile_number",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gender",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "birthdate_timestamp",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "short_address",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "newsletter_subscription",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "receive_push_notifications",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "default_lang",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lat",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phone",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "full_name",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstname",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastname",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address1",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lng",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_building",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_street",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "inwani_zone",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "accept_delivery_and_shipping",
  "args": null,
  "storageKey": null
},
v36 = [
  v13,
  v12
],
v37 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "save_as_default",
  "args": null,
  "storageKey": null
},
v38 = [
  v25,
  v7,
  v26,
  v15,
  v27,
  v28,
  v29,
  v30,
  v12,
  v31,
  v32,
  v33,
  v34,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "country",
    "storageKey": null,
    "args": null,
    "concreteType": "Country",
    "plural": false,
    "selections": [
      v13,
      v12,
      v15,
      v35
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "State",
    "plural": false,
    "selections": v36
  },
  v37
],
v39 = [
  v7,
  v13,
  v12
],
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "club",
  "storageKey": null,
  "args": null,
  "concreteType": "Club",
  "plural": false,
  "selections": v39
},
v41 = [
  v13
],
v42 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "club_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v41
},
v43 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "phone_provider",
  "storageKey": null,
  "args": null,
  "concreteType": "PhoneProvider",
  "plural": false,
  "selections": v39
},
v44 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "phone_provider_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v41
},
v45 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "school",
  "storageKey": null,
  "args": null,
  "concreteType": "School",
  "plural": false,
  "selections": v39
},
v46 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "school_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v41
},
v47 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "employer",
  "storageKey": null,
  "args": null,
  "concreteType": "Employer",
  "plural": false,
  "selections": v39
},
v48 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "employer_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v41
},
v49 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "insurance_company",
  "storageKey": null,
  "args": null,
  "concreteType": "InsuranceCompany",
  "plural": false,
  "selections": v39
},
v50 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "insurance_company_attachment",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": v41
},
v51 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v52 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v53 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "smart_carts",
  "storageKey": null,
  "args": null,
  "concreteType": "Cart",
  "plural": true,
  "selections": [
    v13,
    v51,
    v7,
    v12,
    v52
  ]
},
v54 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "qr_code",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageDetails",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url_thumb",
      "args": null,
      "storageKey": null
    }
  ]
},
v55 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "degree",
  "args": null,
  "storageKey": null
},
v56 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points",
  "args": null,
  "storageKey": null
},
v57 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points_to_next_gift",
  "args": null,
  "storageKey": null
},
v58 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "points_to_next_level",
  "args": null,
  "storageKey": null
},
v59 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "active_gifts_count",
  "args": null,
  "storageKey": null
},
v60 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v61 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "logo_url",
  "args": null,
  "storageKey": null
},
v62 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "silver_start_at",
  "args": null,
  "storageKey": null
},
v63 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "gold_start_at",
  "args": null,
  "storageKey": null
},
v64 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "diamond_start_at",
  "args": null,
  "storageKey": null
},
v65 = [
  v54,
  v55,
  v7,
  v56,
  v57,
  v58,
  v59,
  v12,
  v60,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "vendor",
    "storageKey": null,
    "args": null,
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      v13,
      v61
    ]
  },
  v62,
  v63,
  v64
],
v66 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "referring_code",
  "args": null,
  "storageKey": null
},
v67 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "taxes",
  "args": null,
  "storageKey": null
},
v68 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_in_qar",
  "args": null,
  "storageKey": null
},
v69 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shipping_price",
  "args": null,
  "storageKey": null
},
v70 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "raw_amount",
  "args": null,
  "storageKey": null
},
v71 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "services_only",
  "args": null,
  "storageKey": null
},
v72 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "least_state",
  "args": null,
  "storageKey": null
},
v73 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promo_code",
  "args": null,
  "storageKey": null
},
v74 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "discount",
  "args": null,
  "storageKey": null
},
v75 = [
  v12
],
v76 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "smart_cart",
  "args": null,
  "storageKey": null
},
v77 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "user_smart_cart",
  "args": null,
  "storageKey": null
},
v78 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "same_as_shipping",
  "args": null,
  "storageKey": null
},
v79 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "payment_reference",
  "args": null,
  "storageKey": null
},
v80 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_with_cash",
  "args": null,
  "storageKey": null
},
v81 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount_with_credit",
  "args": null,
  "storageKey": null
},
v82 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v83 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "guest_token",
  "args": null,
  "storageKey": null
},
v84 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "product_type",
  "args": null,
  "storageKey": null
},
v85 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected_billing_address_id",
  "args": null,
  "storageKey": null
},
v86 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "selected_shipping_address_id",
  "args": null,
  "storageKey": null
},
v87 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendor_branch_id",
  "args": null,
  "storageKey": null
},
v88 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total",
  "args": null,
  "storageKey": null
},
v89 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v90 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "promo_total",
  "args": null,
  "storageKey": null
},
v91 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tax_total",
  "args": null,
  "storageKey": null
},
v92 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "adjustment_total",
  "args": null,
  "storageKey": null
},
v93 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "free_shipping",
  "args": null,
  "storageKey": null
},
v94 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "available_payment_methods",
  "storageKey": null,
  "args": null,
  "concreteType": "PaymentMethod",
  "plural": true,
  "selections": [
    v12,
    v7,
    v13
  ]
},
v95 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "created_at",
  "args": null,
  "storageKey": null
},
v96 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v97 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "warnings",
  "storageKey": null,
  "args": null,
  "concreteType": "Error",
  "plural": true,
  "selections": [
    v3,
    v4,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "blocking",
      "args": null,
      "storageKey": null
    }
  ]
},
v98 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "vendor_variants_count",
  "args": null,
  "storageKey": null
},
v99 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "images",
  "args": null,
  "storageKey": null
},
v100 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v101 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total_on_hand",
  "args": null,
  "storageKey": null
},
v102 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "display_price",
  "args": null,
  "storageKey": null
},
v103 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_original",
  "args": null,
  "storageKey": null
},
v104 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "images_attachments",
  "storageKey": null,
  "args": null,
  "concreteType": "ImageAttachment",
  "plural": true,
  "selections": [
    v103,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "url_small",
      "args": null,
      "storageKey": null
    }
  ]
},
v105 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "option_values",
  "storageKey": null,
  "args": null,
  "concreteType": "OptionValue",
  "plural": true,
  "selections": [
    v7,
    v13,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "presentation",
      "args": null,
      "storageKey": null
    }
  ]
},
v106 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "active",
  "args": null,
  "storageKey": null
},
v107 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "address",
  "args": null,
  "storageKey": null
},
v108 = [
  v12,
  v13,
  v107,
  v25,
  v31,
  v32,
  v33,
  v34
],
v109 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "base_price",
  "args": null,
  "storageKey": null
},
v110 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "estimated_delivery_time",
  "args": null,
  "storageKey": null
},
v111 = [
  v12,
  v109,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipping_method",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorShippingMethod",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculator",
        "storageKey": null,
        "args": null,
        "concreteType": "Calculator",
        "plural": false,
        "selections": [
          v60
        ]
      },
      v12,
      v13,
      v110
    ]
  }
],
v112 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "UserPublicInfo",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "avatar_details",
      "storageKey": null,
      "args": null,
      "concreteType": "ImageDetails",
      "plural": false,
      "selections": [
        v103,
        v13
      ]
    },
    v8,
    v9
  ]
},
v113 = [
  v12,
  v13,
  v7
],
v114 = [
  v13,
  v12,
  v7
],
v115 = [
  v25,
  v7,
  v26,
  v15,
  v27,
  v28,
  v29,
  v30,
  v12,
  v31,
  v32,
  v33,
  v34,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "country",
    "storageKey": null,
    "args": null,
    "concreteType": "Country",
    "plural": false,
    "selections": [
      v13,
      v12,
      v15,
      v35,
      v7
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "state",
    "storageKey": null,
    "args": null,
    "concreteType": "State",
    "plural": false,
    "selections": v114
  },
  v37
],
v116 = [
  v54,
  v55,
  v7,
  v56,
  v57,
  v58,
  v59,
  v12,
  v60,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "vendor",
    "storageKey": null,
    "args": null,
    "concreteType": "Shop",
    "plural": false,
    "selections": [
      v13,
      v61,
      v7
    ]
  },
  v62,
  v63,
  v64
],
v117 = [
  v12,
  v7
],
v118 = [
  v12,
  v13,
  v107,
  v25,
  v31,
  v32,
  v33,
  v34,
  v7
],
v119 = [
  v12,
  v109,
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipping_method",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorShippingMethod",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculator",
        "storageKey": null,
        "args": null,
        "concreteType": "Calculator",
        "plural": false,
        "selections": [
          v60,
          v7
        ]
      },
      v12,
      v13,
      v110,
      v7
    ]
  },
  v7
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "CreateSmartCartMutation",
  "id": null,
  "text": "mutation CreateSmartCartMutation(\n  $input: SmartCartInputQuery\n) {\n  add_smart_cart(input: $input) {\n    errors {\n      code\n      field\n      messages\n    }\n    current_user {\n      id\n      ref_id\n      first_name\n      last_name\n      avatar\n      email\n      nationality {\n        ref_id\n        name\n        id\n      }\n      city {\n        ref_id\n        name\n        id\n      }\n      country {\n        ref_id\n        name\n        phone_code\n        id\n      }\n      country_code\n      phone_number\n      mobile_number\n      gender\n      birthdate_timestamp\n      short_address\n      newsletter_subscription\n      receive_push_notifications\n      default_lang\n      default_currency\n      errors {\n        code\n        field\n        messages\n      }\n      shipping_addresses_previous {\n        id\n        ref_id\n        phone\n        phone_code\n        full_name\n        firstname\n        lastname\n        address1\n        lat\n        lng\n        inwani_building\n        inwani_street\n        inwani_zone\n        country {\n          name\n          ref_id\n          phone_code\n          accept_delivery_and_shipping\n          id\n        }\n        state {\n          name\n          ref_id\n          id\n        }\n        save_as_default\n      }\n      billing_addresses_previous {\n        id\n        ref_id\n        phone\n        phone_code\n        full_name\n        firstname\n        lastname\n        address1\n        lat\n        lng\n        inwani_building\n        inwani_street\n        inwani_zone\n        country {\n          name\n          ref_id\n          phone_code\n          accept_delivery_and_shipping\n          id\n        }\n        state {\n          name\n          ref_id\n          id\n        }\n        save_as_default\n      }\n      club {\n        id\n        name\n        ref_id\n      }\n      club_attachment {\n        name\n      }\n      phone_provider {\n        id\n        name\n        ref_id\n      }\n      phone_provider_attachment {\n        name\n      }\n      school {\n        id\n        name\n        ref_id\n      }\n      school_attachment {\n        name\n      }\n      employer {\n        id\n        name\n        ref_id\n      }\n      employer_attachment {\n        name\n      }\n      insurance_company {\n        id\n        name\n        ref_id\n      }\n      insurance_company_attachment {\n        name\n      }\n      smart_carts {\n        name\n        quantity\n        id\n        ref_id\n        amount\n      }\n      ayk_loyalty_program {\n        degree\n        active_gifts_count\n        id\n        points\n        points_to_next_gift\n        points_to_next_level\n        qr_code {\n          url_thumb\n        }\n        ref_id\n        type\n        vendor {\n          name\n          logo_url\n          id\n        }\n        silver_start_at\n        gold_start_at\n        diamond_start_at\n      }\n      vendor_loyalty_programs {\n        degree\n        active_gifts_count\n        id\n        points\n        points_to_next_gift\n        points_to_next_level\n        qr_code {\n          url_thumb\n        }\n        ref_id\n        type\n        vendor {\n          name\n          logo_url\n          id\n        }\n        silver_start_at\n        gold_start_at\n        diamond_start_at\n      }\n      referring_code\n    }\n    smart_cart {\n      id\n      ref_id\n      name\n      amount\n      amount_in_qar\n      quantity\n      shipping_price\n      raw_amount\n      services_only\n      least_state\n      promo_code\n      discount\n      taxes\n      selected_shipping_address {\n        ref_id\n        id\n      }\n      selected_billing_address {\n        ref_id\n        id\n      }\n      smart_cart\n      user_smart_cart\n      same_as_shipping\n      payment_reference\n      amount_with_cash\n      amount_with_credit\n      orders {\n        guest_token\n        amount\n        id\n        product_type\n        selected_billing_address_id\n        selected_shipping_address_id\n        same_as_shipping\n        vendor_branch_id\n        ref_id\n        total\n        notes\n        state\n        promo_total\n        tax_total\n        adjustment_total\n        free_shipping\n        available_payment_methods {\n          ref_id\n          id\n          name\n        }\n        line_items {\n          created_at\n          amount\n          price\n          warnings {\n            field\n            messages\n            blocking\n          }\n          id\n          quantity\n          variant_services {\n            ref_id\n            id\n          }\n          variant {\n            name\n            id\n            ref_id\n            images\n            price\n            slug\n            vendor_variants_count\n            min_variant {\n              vendor {\n                name\n                ref_id\n                id\n              }\n              id\n            }\n            total_on_hand\n            display_price\n            images_attachments {\n              url_original\n              url_small\n            }\n            option_values {\n              id\n              name\n              presentation\n            }\n            vendor {\n              name\n              active\n              id\n            }\n          }\n          total\n        }\n        vendor {\n          name\n          branches {\n            ref_id\n            name\n            address\n            lat\n            lng\n            inwani_building\n            inwani_street\n            inwani_zone\n            id\n          }\n          payment_methods {\n            ref_id\n            name\n            id\n          }\n          id\n        }\n        vendor_branch {\n          ref_id\n          name\n          address\n          lat\n          lng\n          inwani_building\n          inwani_street\n          inwani_zone\n          id\n        }\n        payments {\n          payment_method {\n            ref_id\n            name\n            id\n          }\n          id\n        }\n        shipments {\n          ref_id\n          shipping_rates {\n            ref_id\n            base_price\n            shipping_method {\n              calculator {\n                type\n                id\n              }\n              ref_id\n              name\n              estimated_delivery_time\n              id\n            }\n            id\n          }\n          shipping_rate_selected {\n            ref_id\n            base_price\n            shipping_method {\n              calculator {\n                type\n                id\n              }\n              ref_id\n              name\n              estimated_delivery_time\n              id\n            }\n            id\n          }\n          id\n        }\n      }\n      promotions {\n        ref_id\n        code\n        id\n      }\n      user {\n        avatar_details {\n          url_original\n          name\n        }\n        first_name\n        last_name\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CreateSmartCartMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "add_smart_cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddSmartCartResult",
        "plural": false,
        "selections": [
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "nationality",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v14
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v14
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": [
                  v12,
                  v13,
                  v15
                ]
              },
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v12,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipping_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v38
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "billing_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v38
              },
              v40,
              v42,
              v43,
              v44,
              v45,
              v46,
              v47,
              v48,
              v49,
              v50,
              v53,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ayk_loyalty_program",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": false,
                "selections": v65
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_loyalty_programs",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": v65
              },
              v66
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "smart_cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v67,
              v7,
              v13,
              v52,
              v68,
              v51,
              v69,
              v70,
              v71,
              v72,
              v73,
              v74,
              v12,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_shipping_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v75
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_billing_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v75
              },
              v76,
              v77,
              v78,
              v79,
              v80,
              v81,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "orders",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": true,
                "selections": [
                  v82,
                  v83,
                  v7,
                  v84,
                  v85,
                  v86,
                  v78,
                  v87,
                  v12,
                  v88,
                  v89,
                  v52,
                  v90,
                  v91,
                  v92,
                  v93,
                  v94,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LineItem",
                    "plural": true,
                    "selections": [
                      v95,
                      v52,
                      v96,
                      v97,
                      v7,
                      v51,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant_services",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": true,
                        "selections": v75
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          v98,
                          v13,
                          v12,
                          v99,
                          v96,
                          v100,
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "min_variant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Variant",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "vendor",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Shop",
                                "plural": false,
                                "selections": v36
                              }
                            ]
                          },
                          v101,
                          v102,
                          v104,
                          v105,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v13,
                              v106
                            ]
                          }
                        ]
                      },
                      v88
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shop",
                    "plural": false,
                    "selections": [
                      v13,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "branches",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VendorBranch",
                        "plural": true,
                        "selections": v108
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_methods",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": true,
                        "selections": v14
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_branch",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorBranch",
                    "plural": false,
                    "selections": v108
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Payment",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_method",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": false,
                        "selections": v14
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": true,
                    "selections": [
                      v12,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rates",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": true,
                        "selections": v111
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rate_selected",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": false,
                        "selections": v111
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "promotions",
                "storageKey": null,
                "args": null,
                "concreteType": "Promotion",
                "plural": true,
                "selections": [
                  v12,
                  v2
                ]
              },
              v112
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateSmartCartMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "add_smart_cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "AddSmartCartResult",
        "plural": false,
        "selections": [
          v5,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v6,
              v7,
              v8,
              v9,
              v10,
              v11,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "nationality",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": v113
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "city",
                "storageKey": null,
                "args": null,
                "concreteType": "State",
                "plural": false,
                "selections": v113
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "country",
                "storageKey": null,
                "args": null,
                "concreteType": "Country",
                "plural": false,
                "selections": [
                  v12,
                  v13,
                  v15,
                  v7
                ]
              },
              v16,
              v17,
              v18,
              v19,
              v20,
              v21,
              v22,
              v23,
              v24,
              v12,
              v5,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipping_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v115
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "billing_addresses_previous",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": true,
                "selections": v115
              },
              v40,
              v42,
              v43,
              v44,
              v45,
              v46,
              v47,
              v48,
              v49,
              v50,
              v53,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "ayk_loyalty_program",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": false,
                "selections": v116
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_loyalty_programs",
                "storageKey": null,
                "args": null,
                "concreteType": "LoyaltyProgram",
                "plural": true,
                "selections": v116
              },
              v66
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "smart_cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v67,
              v7,
              v13,
              v52,
              v68,
              v51,
              v69,
              v70,
              v71,
              v72,
              v73,
              v74,
              v12,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_shipping_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v117
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selected_billing_address",
                "storageKey": null,
                "args": null,
                "concreteType": "Address",
                "plural": false,
                "selections": v117
              },
              v76,
              v77,
              v78,
              v79,
              v80,
              v81,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "orders",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": true,
                "selections": [
                  v82,
                  v83,
                  v7,
                  v84,
                  v85,
                  v86,
                  v78,
                  v87,
                  v12,
                  v88,
                  v89,
                  v52,
                  v90,
                  v91,
                  v92,
                  v93,
                  v94,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "line_items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LineItem",
                    "plural": true,
                    "selections": [
                      v95,
                      v52,
                      v96,
                      v97,
                      v7,
                      v51,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant_services",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": true,
                        "selections": v117
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          v98,
                          v13,
                          v12,
                          v99,
                          v96,
                          v100,
                          v7,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "min_variant",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Variant",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "vendor",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Shop",
                                "plural": false,
                                "selections": v114
                              },
                              v7
                            ]
                          },
                          v101,
                          v102,
                          v104,
                          v105,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v13,
                              v106,
                              v7
                            ]
                          }
                        ]
                      },
                      v88
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shop",
                    "plural": false,
                    "selections": [
                      v13,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "branches",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VendorBranch",
                        "plural": true,
                        "selections": v118
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_methods",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": true,
                        "selections": v113
                      },
                      v7
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vendor_branch",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorBranch",
                    "plural": false,
                    "selections": v118
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Payment",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "payment_method",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PaymentMethod",
                        "plural": false,
                        "selections": v113
                      },
                      v7
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipments",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Shipment",
                    "plural": true,
                    "selections": [
                      v12,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rates",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": true,
                        "selections": v119
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "shipping_rate_selected",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ShippingRate",
                        "plural": false,
                        "selections": v119
                      },
                      v7
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "promotions",
                "storageKey": null,
                "args": null,
                "concreteType": "Promotion",
                "plural": true,
                "selections": [
                  v12,
                  v2,
                  v7
                ]
              },
              v112
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '816ccbe317b5a40b3ec9ef2d3d5a4b83';
module.exports = node;
